/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_item = {
    readonly serviceId: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
    readonly defaultSkuId: string | null;
    readonly itemType: string | null;
    readonly isJewelry: boolean | null;
    readonly isFashion: boolean | null;
    readonly seller?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_seller">;
    } | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly skuLeadTime: string | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespExitModal_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespBreadcrumbs_item" | "PdpRespHeroCarouselPrint_item" | "PdpRespIconBubblesWrapper_item" | "PdpRespTitle_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarBlurbs_item" | "PdpSharedDescriptionAbout_item" | "PdpSharedDescriptionAdditionalOptions_item" | "PdpRespShippingReturns_item" | "PdpRespSidebarContact_item" | "PdpRespSimilarItemsGridSeller_item" | "PdpRespSimilarItemsFooter_item" | "PdpSharedQuantitySelect_item" | "PdpSharedRecentHistoryTracker_item" | "PriceDisplay_item" | "PdpSharedPromoCode_item" | "PdpRespSwatchSelector_item" | "SuspectedTradeUserLoader_item" | "PdpSharedShippingBadge_item" | "PdpSharedShippingDetails_item" | "PdpSharedTradePointsEarnedMessage_item" | "PdpRespDealerDetails_item" | "PdpRespHeroCarousel_item" | "PdpRespDetails_item" | "PdpSharedDescriptionAboutCreator_item" | "PdpSharedDescriptionAboutMaker_item" | "PdpRespSeoLinks_item">;
    readonly " $refType": "PdpRespContainer_item";
};
export type PdpRespContainer_item$data = PdpRespContainer_item;
export type PdpRespContainer_item$key = {
    readonly " $data"?: PdpRespContainer_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpRespContainer_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": null
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstPhotoWebPath",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "defaultSkuId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "itemType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isJewelry",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isFashion",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "skus",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": "skuLeadTime",
          "name": "leadTime",
          "args": [
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "PDP"
            }
          ],
          "storageKey": "leadTime(pageType:\"PDP\")"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespExitModal_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselPrint_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAbout_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptions_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGridSeller_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentHistoryTracker_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item",
      "args": [
        {
          "kind": "Variable",
          "name": "hasUserId",
          "variableName": "fetchUser"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isMultiSku",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_item",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingDetails_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedTradePointsEarnedMessage_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "fetchPdp",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfo_seller",
              "args": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerDetails_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDetails_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDescriptionAboutCreator_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDescriptionAboutMaker_item",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespSeoLinks_item",
          "args": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'ea7f5003b1a92daaf0a08d9ce30ecde9';
export default node;
